module.exports = __webpack_public_path__ + "img/content_2_header.ef80e823.jpg";